import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_icon = _resolveComponent("t-icon")!

  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, {
    class: _ctx.getClasses.wrap,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.listener && _ctx.listener(...args)))
  }), [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClasses.control)
    }, [
      _createVNode(_component_t_icon, {
        size: "small",
        theme: _ctx.getIconTheme,
        "icon-name": _ctx.getIconShape,
        class: _normalizeClass(_ctx.getClasses.icon)
      }, null, 8, ["theme", "icon-name", "class"])
    ], 2),
    (_ctx.title || _ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.getClasses.content)
        }, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.getClasses.title)
            }, _toDisplayString(_ctx.title), 3)
          ], true)
        ], 2))
      : _createCommentVNode("", true)
  ], 16))
}